import React from 'react'
import SelectField from '../../molecules/fields/SelectField'
import PropTypes from 'prop-types'
import { useAuth } from '../../molecules/Auth'
import AutoSaveForm from '../../molecules/AutoSaveForm'
import { dataToOptions } from '../../../utils/helpers'

const name = 'indicator'
const ChartIndicator = ({ changeIndicator, fetchFilteredData, initialFilters }) => {
  const { user } = useAuth()
  const currentRole = user.role

  const indicatorOptions = [
    { id: 'users', name: 'Usuarios registrados' },
    { id: 'institutions', name: 'Entidades registradas' },
    { id: 'forms', name: 'Formularios creados' },
    { id: 'answers', name: 'Respuestas recibidas' },
    { id: 'receivedRequests', name: 'Estados de solicitud' },
    { id: 'attendedRequests', name: 'Porcentaje de solicitudes atendidas' }
  ]

  const accessRules = {
    admin: ['users', 'institutions', 'forms', 'answers', 'receivedRequests', 'attendedRequests'],
    coordinator: ['users', 'forms', 'answers', 'receivedRequests', 'attendedRequests'],
    branch_coordinator: ['users', 'forms', 'answers', 'receivedRequests', 'attendedRequests'],
    collaborator: ['forms', 'answers', 'receivedRequests', 'attendedRequests']
  }

  const getAvailableIndicators = role => {
    return indicatorOptions.filter(option => accessRules[role].includes(option.id))
  }

  const availableIndicators = getAvailableIndicators(currentRole)

  const handleChange = value => {
    changeIndicator(value)
  }

  return (
    <AutoSaveForm onSubmit={fetchFilteredData} initialValues={initialFilters}>
      <SelectField
        onChange={handleChange}
        label="Indicador"
        hint="Selecciona un indicador para revisar más información"
        name={name}
        options={dataToOptions(availableIndicators)}
      />
    </AutoSaveForm>
  )
}

ChartIndicator.propTypes = {
  changeIndicator: PropTypes.func.isRequired,
  fetchFilteredData: PropTypes.func.isRequired,
  initialFilters: PropTypes.object.isRequired
}
export default ChartIndicator
